export const DEFAULT_TRACES_SAMPLE_RATE = 0.1;

export const parseSentrySampleRate = (value: unknown, onInvalid?: () => void) => {
    if (typeof value === 'number') {
        if (value >= 0 && value <= 1) return value;
        onInvalid?.();
        return DEFAULT_TRACES_SAMPLE_RATE;
    }

    if (typeof value === 'string' && value.trim() !== '') {
        const parsed = Number.parseFloat(value);
        if (Number.isFinite(parsed) && parsed >= 0 && parsed <= 1) return parsed;
    }

    if (value !== undefined && value !== null && value !== '') {
        onInvalid?.();
    }

    return DEFAULT_TRACES_SAMPLE_RATE;
};
